import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Box } from '@drone-js/core';
import { selectIsAnyOverlayVisible } from 'store/slice/overlay';
import { innerHeight } from 'core-framework/window/screen';
import { DetailPageContentProps, FooterType, mapDispatchToProps, mapStateToProps } from 'component/page/deprecatedDetail/DetailPageContent/DetailPageContent.selectors';
import { defaultExpandedAccordion, NavigationHashEnum } from 'core/type/Details.types';
import { ElementEventIds } from '@agoda/analytics-messages-definition-activities';
import ContentArea from 'component/common/ContentArea/ContentArea';
import DetailCard from 'component/page/deprecatedDetail/DetailCard/DetailCard';
import ActivityDetailsFooter from 'component/page/deprecatedDetail/ActivityDetailsFooter/ActivityDetailsFooter';
import MosaicGallery from 'component/page/deprecatedDetail/DetailCard/ActivityCarousel/MosaicGallery';
import OfferCardFooter from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter';
import { OfferCardFooterType } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter.selectors';
import { DetailsSectionTab } from 'component/page/deprecatedDetail/DetailPageContent/DetailsSectionTab';
import RecentReviewsSection from 'component/page/detail/Review/RecentReviewsSection/RecentReviewsSection';
import { selectScreenSize } from 'store/slice/screen';

const ViewportHeight: React.CSSProperties = { height: `${innerHeight}px` };

interface FooterProps {
    footerType: FooterType;
}

const Footer: React.FC<FooterProps> = ({ footerType }) => {
    switch (footerType) {
        case FooterType.Booking:
            // We only have one DetailsFooter so we use first index
            return <OfferCardFooter footerType={OfferCardFooterType.Sticky} offerIndex={0} />;
        case FooterType.Details:
            return <ActivityDetailsFooter />;
        default:
            return null;
    }
};

Footer.displayName = 'ActivitiesDetailsFooter';

const DetailPageContent: React.FC<DetailPageContentProps> = (props: DetailPageContentProps) => {
    const isAnyOverlayVisible: boolean = useSelector(selectIsAnyOverlayVisible);
    const screenSize = useSelector(selectScreenSize);
    const onToggle = (selector: string | undefined, eventIds: ElementEventIds) => (isExpanded: boolean) => props.sendAccordionClickAnalytics(isExpanded, selector || '', eventIds);
    const tabs = props.tabs;
    const [reviewHref, useReviewHref] = React.useState<string>('');

    React.useEffect(() => {
        tabs.forEach((tab) => {
            if (defaultExpandedAccordion[tab.id]) {
                props.setExpandedAccordionOnDetailsPage(tab.href);
            }
            if (tab.id === NavigationHashEnum.ReviewSection) {
                // eslint-disable-next-line react-hooks/rules-of-hooks
                useReviewHref(tab.href);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div data-testid="activities-detail-page" data-prerender-name="activities-detail-page" style={ViewportHeight}>
            <Box minHeight="100vh" py="0" pb="12" data-testid="details-page" aria-hidden={isAnyOverlayVisible} backgroundColor="base.surface">
                <div className="ContentArea align-center">
                    <ContentArea>
                        <MosaicGallery />
                        <Box key="contentContainer" px="8" pb="12">
                            {/* Please order what we want to display */}
                            <DetailCard seeReviewHref={reviewHref} />
                            {screenSize.tabletOrDesktop && props.recentReviews && <RecentReviewsSection reviewSectionHref={reviewHref} />}
                            {tabs.map((tab) => {
                                return <DetailsSectionTab key={tab.id} tab={tab} onToggle={onToggle} isScrolling={props.isScrolling} />;
                            })}
                        </Box>
                    </ContentArea>
                </div>
            </Box>
            <Footer footerType={props.footerType} />
        </div>
    );
};
DetailPageContent.displayName = 'DetailPageContent';

export default connect(mapStateToProps, mapDispatchToProps)(DetailPageContent);
